<script setup lang="ts">
    import { useToast } from "vue-toastification";
    import { useThemeConfig } from '@core/composable/useThemeConfig';
    import UpdateAvailableDialog from "@/components/app/Dialogs/UpdateAvailableDialog.vue";

    const {
        syncInitialLoaderTheme,
        syncVuetifyThemeWithTheme: syncConfigThemeWithVuetifyTheme,
        isAppRtl,
    } = useThemeConfig();

    const toast = useToast();
    const route = useRoute();
    const router = useRouter();

    syncInitialLoaderTheme();
    syncConfigThemeWithVuetifyTheme();

    const handleEmailVerificationResult = (): void => {
        const verified: string | undefined = new URLSearchParams(window.location.search).get('verified') ?? undefined;

        if(verified !== 'true' && verified !== 'false') {
            return;
        }

        if(verified === 'true') {
            toast.success("Deine E-Mail-Adresse wurde erfolgreich bestätigt. Du kannst dich jetzt einloggen.");
        }
        else {
            toast.error("Der Bestätigungslink ist ungültig oder abgelaufen. Bitte fordere einen neuen an.");
        }

        const query: Record<string, unknown> = { ...route.query };
        delete query.verified;

        router.replace({ query });
    };

    onMounted((): void => {
        router.isReady().then(handleEmailVerificationResult);
    });
</script>

<template>
  <VLocaleProvider :rtl="isAppRtl">
    <VApp>
      <VMain>
        <update-available-dialog/>
        <RouterView />
      </VMain>
    </VApp>
  </VLocaleProvider>
</template>